import { BannerLogoConfig } from 'features/banners';

function getLogoUrl({ logoId, layoutId }): string {
  return BannerLogoConfig[logoId] ? BannerLogoConfig[logoId][layoutId] : undefined;
}

export { getLogoUrl };
